import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import UserData from './UserData';

const GetUserInfoQuery = gql`
  query UserDataUserInfo {
    userInfo {
      id
      
      email
      phone
      
      receiveNewsletter
      
      companyInformation
      companyName
      companyRegistrationNumber
      companyVatNumber
      companyVatValidationDate

      invoiceFirstName
      invoiceLastName
      
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      anotherDeliveryAddress
      deliveryPhone
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      saleTaxCertificate
    }
  }
`;

const CountriesQuery = gql`
  query countries {
    countries {
      id
      parentCountryId
      name
      title
      details
      slug
      VATrate
      currency
      language
      code
      flag
      weightUnit
      states {
        id
        name
        title
        vatRate
      }
    }
  }
`;

const UpdateUserInfoMutation = gql`
  mutation updateUserInfo($user: IUserInput!) {
    updateUserInfo(userData: $user)
  }
`;

const RequestCompanyChangeMutation = gql`
  mutation requestCompanyChange($user: IUserInput!) {
    requestCompanyChange(userData: $user)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(CountriesQuery, {
    name: 'countries'
  }),
  graphql<IInputProps, IResponse>(GetUserInfoQuery, {
    options: {
      fetchPolicy: 'network-only',
    },
  }),
  graphql<IInputProps, IResponse>(UpdateUserInfoMutation, {
    name: 'updateUserInfo'
  }),
  graphql<IInputProps, IResponse>(RequestCompanyChangeMutation, {
    name: 'requestCompanyChange'
  })
)(UserData);



// WEBPACK FOOTER //
// ./src/pages/UserData/index.tsx